module.exports = __webpack_public_path__ + "img/achievementsRight.ca142562.jpg";